module.exports = __webpack_public_path__ + "static/media/bfile-brokerage-account.d33531af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-brokerage-account.svg
// module id = 253
// module chunks = 0